import { SideBarFloat } from './SideBarFloat';
export default SideBarFloat;
